<div>
  <i class="material-icons me-2">{{ iconName }}</i> <span>{{ textToShow }}</span>
</div>
